export class SysUserGroup {
    userGroupid: number;
    code: string;
    name: string;
    notes: string;    
   }